export default class Arr {
    static sortByDateKey(data, key) {
        return data.sort((firstSchedule, secondSchedule) => {
            if (new Date(firstSchedule[key]) > new Date(secondSchedule[key])) {
                return 1;
            }

            if (new Date(firstSchedule[key]) < new Date(secondSchedule[key])) {
                return -1;
            }

            return 0;
        });
    }

    static sortByTimeKey(data, key) {
        return data.sort((firstSchedule, secondSchedule) => {
            const firstDate = new Date(firstSchedule[key]);
            const secondDate = new Date(secondSchedule[key]);
            const firstDateMinutes = firstDate.getHours() * 60 + firstDate.getMinutes();
            const secondDateMinutes = secondDate.getHours() * 60 + secondDate.getMinutes();


            if (firstDateMinutes > secondDateMinutes) {
                return 1;
            }

            if (firstDateMinutes < secondDateMinutes) {
                return -1;
            }

            return 0;
        });
    }
}
